import { ListingGroupColumn, AssetGroupNameColumn } from '../rawColumns';

const isColumnSortEnabledMap: Map<string, boolean> = new Map([
  [ListingGroupColumn.key, true],
  [AssetGroupNameColumn.key, true],
]);

export function isSortEnabledByColumnKey(columnKey: string): boolean {
  if (isColumnSortEnabledMap.has(columnKey)) {
    return isColumnSortEnabledMap.get(columnKey)!;
  }
  return false;
}
